import { createContext } from "react";

export const FocusableContext = createContext(true);
